import { HttpClient } from './client'
import { TokenManager } from '../auth/tokenManager'

export interface ConfidenceScoreEntry {
  score: number
  nodeCategory: 'need' | 'idea'
  dimensions: Record<string, number> | null
  reasoning: string | null
  computedAt: string
}

export type ConfidenceScoresMap = Record<string, ConfidenceScoreEntry>

export async function fetchConfidenceScores(
  mindmapId: string
): Promise<ConfidenceScoresMap | null> {
  const headers = await TokenManager.getAuthHeaders()
  const result = await HttpClient.get<ConfidenceScoresMap>(
    `/mindmaps/${mindmapId}/confidence-scores`,
    headers
  )
  if (result.error) return null
  return result.data ?? null
}
